import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import className from "../../style.module.scss";

export function CheckboxControl(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const [value, setValue] = useState(props.configData.default);

  useEffect(() => {
    props.updateVariable(props.configData.variable_key, value, props.index);
  }, [value]);

  const updateControl = () => {
    setValue(!value);
  };

  return (
    <label className={className.toggle}>
      <input
        className={className.checkbox}
        type="checkbox"
        checked={value}
        value={t(`${props.configData.name}.string`)}
        name={`checkbox_${props.index}`}
        aria-label={t(`${props.configData.name}.string`)}
        onChange={() => updateControl()}
      />
      <span className={className.slider}></span>
    </label>
  );
}

CheckboxControl.propTypes = {
  configData: PropTypes.shape({
    default: PropTypes.any.isRequired,
    variable_key: PropTypes.string.isRequired,
  }).isRequired,
  updateVariable: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
CheckboxControl.defaultProps = {};
